import React from "react";

export default function ContactCard() {
  return (
    <div className="p-4 bg-light w-100 rounded">
      <h5 className="text-primary fw-semibold pb-3">Contact us at:</h5>
      <div>
        <div className="d-flex flex-row gap-4">
          <p>Tel. No.:</p>
          <div>
            <p className="m-0 pb-1">(+632) 910 8115</p>
            <p>(+632) 636 3053</p>
          </div>
        </div>
        <div className="d-flex flex-row gap-4">
          <p>Telfax:</p>
          <div>
            <p className="m-0 pb-1">(+632) 633 5309</p>
          </div>
        </div>
        <div className="d-flex flex-row gap-4">
          <p>Mobile:</p>
          <div>
            <p className="m-0 pb-1">(+63) 997 917 7218</p>
            <p className="m-0 pb-1">(+63) 975 584 5454</p>
            <p>(+63) 997 834 5166</p>
          </div>
        </div>
        <div className="d-flex flex-row gap-4">
          <p>Email:</p>
          <div>
            <p className="m-0 pb-1">ffcc@forbesfinancial.com.ph</p>
          </div>
        </div>
      </div>
    </div>
  );
}
